@file:UseSerializers(BigDecimalSerializer::class)
@file:Suppress("KDocUnresolvedReference")

package net.sergeych.ugdx.shared

import com.ionspin.kotlin.bignum.decimal.BigDecimal
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers

@Suppress("unused")
@Serializable
data class Currency(
    /**
     * This is a unique code. It could be used as currency id. Another way to uniquely identify a currency,
     * is to ise pair realm:specificKey. In the case of duplicating currency names in different (say) realsm
     * code should be adjusted to remain unique, by adding, for example, short prefix rescribing the realm.
     */
    val code: String,
    /**
     * Special symbol, if exists, otherwise (usually) we use the code
     */
    val symbol: String,
    /**
     * Where the currency comes from: real world, universa, ethereum, whatever.
     */
    val realm: Realm,
    /**
     * Platform-specicic unique key that allow to check/identify token in the platform
     */
    val specificKey: String,
    /**
     * Human readable name, like Euro or "Sooper Tooper token"
     */
    val name: String,
    /**
     * Optional description could be added to a currency too
     */
    val description: String?,
    /**
     * Approved by the administration: means, that platofrm beleives this is not a short-living scum. Nut not
     * guranteeed ;) Usually it is set for long-known authentic tokens and hard currencies if any
     */
    val isApproved: Boolean,

    val canExport: Boolean = true,

    val canCreateAccount: Boolean = true,
    /**
     * The estimated real-world or local rate against a base currency reported bu a server or a [GuestAPI().baseCurrency]
     */
    val baseRate: BigDecimal?,

    /**
     * Default rounding scale for imprecise operations like division. Please use banking
     * rounding mode for such operations
     */
    val roundingScale: Int = 12
) {

    /**
     * Expermiental api to rates. do not yet use.
     */
    @Serializable data class Rate(val base: Currency, val quote: Currency,val rate: BigDecimal) {
        override fun toString(): String {
            return "${base.code}${quote.code} $rate"
        }
    }


    enum class Realm {
        FIAT,
        ETHEREUM,
        BITCOIN,
        UNIVERSA,
        RINKEBY,
        TEST
    }

    override fun toString(): String = code

    override fun equals(other: Any?): Boolean = other is Currency && other.code == code

    override fun hashCode(): Int = code.hashCode()
}

@Serializable data class GetCurrenciesResult(
    val baseCurrency: Currency,
    val currencies: List<Currency>
)

@Suppress("unused")
@Serializable
class GetEthSignatureMessageArgs(
    val address: String,
    val realm: Currency.Realm
)

@Serializable
class GetEthSignatureMessageResult(
    val message: String
)

@Suppress("unused")
@Serializable
class AddEthAddressArgs(
    val name: String,
    val address: String,
    val signature: String,
)